<template>
     <div class="bg-main">
          <RovinietaNavigation v-if="!disableNavigation"></RovinietaNavigation>
          <router-view @verifiedStatus="setVerifiedStatus"></router-view>
     </div>
</template>

<script>

import Heading from './../snippets/Heading.vue'
import RovinietaNavigation from '../RovinietaNavigation.vue'
import {mapGetters} from 'vuex'

export default {
     name: 'OrderContainer',
     components: {
          Heading,
          RovinietaNavigation
     },
     data() {
          return {
               hasCompletedBillingFields: false
          }
     },
     props: {
     },
     computed: {
         disableNavigation() {
             return ['cart', 'billing', 'payment'].includes(this.$router.currentRoute.name);
         } 
     },
     mounted() {
     },
     methods: {
          ...mapGetters('cart', [
               'cartCount'
          ]),

          setVerifiedStatus(status) {
               this.hasCompletedBillingFields = status;
          }
     }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

$lightgrey: lightgrey;
$green: #59af54;

.bg-main{
     background-color: #FAF9F6;
     padding-bottom: 120px;
}

.router-link-exact-active {
     border-bottom-color: $green !important;
     border-bottom-width: 3px !important;
     border-bottom-style: solid !important;
     color: $green !important;
     p {
          color: $green !important;
     }
     .fa-shopping-cart {
          color: $green !important;
     }
     .fa-file-alt {
          color: $green !important;
     }
     .fa-credit-card {
          color: $green !important;
     }
}

.checkout-tab-button {
     padding: 7px 5px 1px 5px;
     display: block;
     .fa-shopping-cart {
          font-size: 20px;
          color: $lightgrey;
     }
     .fa-file-alt {
          font-size: 20px;
          color: $lightgrey;
     }
     .fa-credit-card {
          font-size: 20px;
          color: $lightgrey;
     }
     p {
          font-size: 10px;
          color: $lightgrey;
          margin-bottom: 0px;
     }
}

</style>
